import React from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import { selectSelected } from "./brqaSlice";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utility";
import Swal from "sweetalert2";

export const BrqaDetail = () => {
  const history = useHistory();
  const items = useSelector(selectSelected);

  // Return if data null
  if (items === null) {
    history.push("/brqa");
  }

  return items === null ? null : (
    <Card>
      <CardHeader title="Brqa Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.retNumber} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Reason</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.reasonName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Sales Offcie</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.aplSalesOffice} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Cust Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.customerName} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Doc Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={formatDate(items.docDate)} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Code</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.clientCode} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.clientName} />
                </Col>
              </Form.Group>
            </Col>
            {/* Row kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialCode} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material Desc</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialName} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Batch</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.batch} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Exp Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    disabled
                    value={formatDate(items.expiredDate)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.uom} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Qty</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.qty} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Photo Product</b>
                </Form.Label>
                <Col sm={8}>
                  <Button
                    variant="light"
                    className="mr-3"
                    onClick={() => {
                      if (items.attachmentURL === "") {
                        Swal.fire("No Image", "No image attached!", "error");
                      } else {
                        const url = `${process.env.REACT_APP_API_URL}${items.attachmentURL}`;
                        window.open(url, "_blank").focus();
                      }
                    }}
                  >
                    <i className="fa fa-image"></i>
                  </Button>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Remarks</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.remark} />
                </Col>
              </Form.Group>
            </Col>
            {/* end kiri */}
          </Form.Group>
        </Form>
        <Row className="mt-6">
          <Button
            variant="light"
            className="mr-3"
            onClick={() => history.push("/brqa")}
          >
            <i className="fa fa-arrow-left" />
            Back
          </Button>
        </Row>
      </CardBody>
    </Card>
  );
};
